const { registerBlockType } = wp.blocks;

import Editor from "./Editor";
import Save from "./Save";

registerBlockType('custom-form/checkbox', {
  title: 'Checkbox',
  description: '',
  icon: 'yes',
  category: 'widgets',
  parent: ['custom-form/block'],
  attributes: {
    text: {
      type: 'boolean',
      default: false
    },
    fieldId: {
      type: 'string',
    }
  },

  edit: props => <Editor {...props} />,
  save: props => <Save {...props} />
});
